import React from 'react';
import { Zuweisung } from '../../types';

interface ConflictAlertProps {
  conflictingZuweisungen: Zuweisung[];
}

const ConflictAlert: React.FC<ConflictAlertProps> = ({ conflictingZuweisungen }) => {
  if (!conflictingZuweisungen || conflictingZuweisungen.length === 0) {
    return null;
  }

  return (
    <div className="bg-red-50 border-l-4 border-red-500 p-4 mb-4">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-red-500"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3 flex-1">
          <h3 className="text-sm font-medium text-red-800">Zeitkonflikt erkannt</h3>
          <div className="mt-2 text-sm text-red-700">
            <p className="mb-2">
              Der Arzt ist bereits zur gleichen Zeit an einer anderen Praxis eingeplant:
            </p>
            <ul className="list-disc list-inside space-y-1">
              {conflictingZuweisungen.map((zuweisung) => (
                <li key={zuweisung.id}>
                  <strong>{zuweisung.praxis?.name || 'Unbekannte Praxis'}</strong> -{' '}
                  {new Date(zuweisung.datum).toLocaleDateString('de-DE')} -{' '}
                  <span className="font-semibold">
                    {zuweisung.zeitslot === 'VORMITTAG' ? 'Vormittag' : 'Nachmittag'}
                  </span>
                </li>
              ))}
            </ul>
            <p className="mt-2 font-medium">
              Bitte wählen Sie einen anderen Zeitslot oder ein anderes Datum.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConflictAlert;
